
import { Component, Vue } from 'vue-property-decorator'
import { Getter, Action } from "vuex-class";
import { handleFill } from '@/utils/util'
import Price from '@/components/Price/index.vue'
import { getStoreOrderList } from '@/api/industryMall'
@Component({
  name: 'orderManage',
  components: {
    Price
  }
})
export default class orderManage extends Vue {
  @Getter companyId!: string
  handleFill = handleFill
  searchKey = ''
  activeStatus: any = '0'
  refreshing = false
  loading = false
  finished = false
  params: any = {
    pageIndex: 1,
    pageSize: 20
  }
  totalRecords = 0
  orderList: any[] = []
  statusOptions = [
    { name: '全部', value: '0', isTab: true }, // value对应的是订单状态
    { name: '未支付', value: '1', isTab: true },
    { name: '已支付', value: '2',  isTab: true }
  ]
  mounted() {
    const { activeStatus = '0' } = this.$route.query
    this.activeStatus = activeStatus
    this.getOrderList()
  }
  
  get tabs () {
    return this.statusOptions.filter((item: any) => item.isTab)
  }

  onSearch(value: string) {
    this.searchKey = value
    this.params.pageIndex = 1;
    this.getOrderList()
  }

  changeTabs(name, title) {
    document.querySelector('.order-scroll').scrollTop = 0
    // this.activeStatus = name
    this.params.pageIndex = 1;
    this.getOrderList()
  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getOrderList()
  }

  getOrderList () {
    getStoreOrderList({
      storeId: this.companyId,
      pageIndex: this.params.pageIndex,
      pageSize: this.params.pageSize,
      queryContent: this.searchKey,
      payStatus: this.activeStatus
    })
    .then((res) => {
      if (this.refreshing || this.params.pageIndex === 1) {
        this.orderList = [];
      }
      this.orderList = this.orderList.concat(res.data.records);
      this.totalRecords = res.data.totalRecords
      if (this.params.pageIndex >= res.data.totalPages) {
        this.finished = true;
      } else {
        this.finished = false;
      }
      this.refreshing = false;
    })
    .catch(() => {
      this.finished = true;
    })
    .finally(() => {
      this.loading = false;
    });
  }

  /**
   * 上拉加载更多
   */
  onLoad () {
    this.params.pageIndex++;
    this.getOrderList();
  }

  toDetail(item: any) {
    this.$router.push({
      path: '/mendianOrderlDetail',
      query: {
        orderId: item.orderId,
        orderStatus: item.payStatus,
        activeStatus: this.activeStatus
      }
    })
  }
}
